<template>
  <UiField
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :class="{ 'txt-muted': disabled }"
    v-bind="$attrs"
  >
    <AutoSpinner>
      <BaseSelect
        :options="options"
        :value="value"
        :model-modifiers="{ lazy: true }"
        :search="search"
        :position="position"
        :alignment="alignment"
        :multiple="multiple"
        :size="size"
        :aria-label="ariaLabel || label"
        :custom="custom"
        @input="handleInput"
        @open="handleOpen"
        @close="handleClose"
      />
    </AutoSpinner>
  </UiField>
</template>

<script setup>
import UiField from '@nicolaudie-group/ng-ui-kit/components/UiField/UiField.vue'
import BaseSelect from '@nicolaudie-group/ng-ui-kit/components/Select/BaseSelect.vue'
import AutoSpinner from '@nicolaudie-group/ng-ui-kit/components/AutoSpinner/AutoSpinner.vue'

defineOptions({
  compatConfig: {
    MODE: 3,
    INSTANCE_LISTENERS: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
  },
  inheritAttrs: false,
})

defineProps({
  label: { type: String, default: undefined },
  ariaLabel: { type: String, default: undefined },
  loading: { type: Boolean, default: false },
  /**
   * Previously: readOnly
   */
  disabled: { type: Boolean, default: undefined },
  /**
   * Previously: items
   */
  options: { type: Array, required: true },
  value: { type: [String, Number, Array], required: true },
  /**
   * Previously: editable
   */
  search: { type: Boolean, default: false },
  /**
   * Allow inputting custom values in the search field, and select them
   */
  custom: { type: Boolean, default: false },
  /**
   * Dropdown alignment
   */
  alignment: { type: String, default: undefined },
  /**
   * Dropdown position
   */
  position: { type: String, default: undefined },
  multiple: { type: Boolean, default: false },
  /**
   * Listbox minimal width
   */
  size: { type: String, default: undefined },
})

const emit = defineEmits(['input', 'change', 'open', 'close'])

function handleInput(...args) {
  emit('input', ...args)
}

function handleOpen(...args) {
  emit('open', ...args)
}

function handleClose(...args) {
  emit('close', ...args)
}
</script>
